import { render, staticRenderFns } from "./FormularioView.vue?vue&type=template&id=a9218d40&"
import script from "./FormularioView.vue?vue&type=script&lang=ts&"
export * from "./FormularioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports